let mirrorDiv: HTMLDivElement | null = null;

const getMirrorDiv = () => {
  if (!mirrorDiv) {
    mirrorDiv = document.createElement("div");
    mirrorDiv.style.position = "absolute";
    mirrorDiv.style.visibility = "hidden";
    mirrorDiv.style.top = "-9999px";
    mirrorDiv.style.left = "-9999px";
    mirrorDiv.style.overflow = "hidden";
    document.body.appendChild(mirrorDiv);
  }

  return mirrorDiv;
};

/**
 * Computes the caret's pixel position within a textarea, relative to the
 * textarea's own padding-box origin, using the standard hidden-mirror-div
 * technique (a hidden div reproduces the textarea's text layout so a marker
 * span placed at the caret index can be measured with offsetTop/offsetLeft).
 */
export const getCaretCoordinates = (
  element: HTMLTextAreaElement,
  position: number,
) => {
  const div = getMirrorDiv();
  const computed = window.getComputedStyle(element);

  div.style.boxSizing = computed.boxSizing;
  div.style.width = `${element.clientWidth}px`;
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontWeight = computed.fontWeight;
  div.style.fontStyle = computed.fontStyle;
  div.style.letterSpacing = computed.letterSpacing;
  div.style.textTransform = computed.textTransform;
  div.style.wordSpacing = computed.wordSpacing;
  div.style.lineHeight = computed.lineHeight;
  div.style.whiteSpace = "pre-wrap";
  div.style.wordBreak = computed.wordBreak;
  div.style.overflowWrap = "break-word";
  div.style.paddingTop = computed.paddingTop;
  div.style.paddingRight = computed.paddingRight;
  div.style.paddingBottom = computed.paddingBottom;
  div.style.paddingLeft = computed.paddingLeft;
  div.style.borderTopWidth = computed.borderTopWidth;
  div.style.borderRightWidth = computed.borderRightWidth;
  div.style.borderBottomWidth = computed.borderBottomWidth;
  div.style.borderLeftWidth = computed.borderLeftWidth;

  div.textContent = element.value.substring(0, position);

  const marker = document.createElement("span");
  marker.textContent = element.value.substring(position) || ".";
  div.appendChild(marker);

  const coordinates = {
    top: marker.offsetTop,
    left: marker.offsetLeft,
    height: parseInt(computed.lineHeight, 10) || marker.offsetHeight,
  };

  div.textContent = "";

  return coordinates;
};
